<template>
  <div id="amazingDiscount" class="main-container amazingDiscount ">
    <div class="baner_flash">
      <router-link :to="'/products?sort=most_discount'" class="products__slider__info__top1 w-100 d-inline-block">
        <picture class="m-0 d-inline-block w-100">
          <source media="(max-width:600px)" srcset="../../../../assets/images/banerFlashmobile.jpg" />
          <img decoding="async" width="1275" height="135" class="w-100 h-auto" loading="lazy"
            src="../../../../assets/images/banerFlash.jpg" alt="" />
        </picture>
      </router-link>
    </div>
    <div class="products__slider__content">
      <div class="products__slider">
        <div class="title_products_flash">
          <router-link :to="'/products?sort=most_discount'" class="products__slider__info__top1">
            <div class="text-row word-rotate-box c-black border-white">
              <svg class="badge__emoji" xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"
                fill="none">
                <g clip-path="url(#clip0_161_568)">
                  <path
                    d="M10.7239 31.3072L19.0059 39.5891C19.2696 39.8523 19.627 40.0001 19.9995 40.0001C20.3721 40.0001 20.7295 39.8523 20.9932 39.5891L29.2752 31.3072C29.4582 31.1236 29.5608 30.8748 29.5606 30.6156C29.5604 30.3564 29.4573 30.1078 29.274 29.9245C29.0907 29.7412 28.8421 29.6381 28.5829 29.6379C28.3237 29.6377 28.075 29.7404 27.8913 29.9234L20.9781 36.8368V0.978516C20.9781 0.718997 20.875 0.470108 20.6915 0.286601C20.508 0.103093 20.2591 0 19.9995 0C19.74 0 19.4911 0.103093 19.3076 0.286601C19.1241 0.470108 19.021 0.718997 19.021 0.978516V36.8368L12.1077 29.9234C11.9241 29.7404 11.6754 29.6377 11.4162 29.6379C11.1569 29.6381 10.9084 29.7412 10.7251 29.9245C10.5418 30.1078 10.4387 30.3564 10.4385 30.6156C10.4383 30.8748 10.5409 31.1236 10.7239 31.3072Z"
                    fill="#000"></path>
                </g>
                <defs>
                  <clipPath id="clip0_161_568">
                    <rect width="40" height="40" fill="#000"></rect>
                  </clipPath>
                </defs>
              </svg>

              <span class="text__char" style="--char-rotate: 0deg">a</span>
              <span class="text__char" style="--char-rotate: 16.36363636363636deg">n</span>
              <span class="text__char" style="--char-rotate: 32.72727272727272deg">g</span>
              <span class="text__char" style="--char-rotate: 49.09090909090908deg">e</span>
              <span class="text__char" style="--char-rotate: 65.45454545454544deg">l</span>
              <span class="text__char" style="--char-rotate: 81.8181818181818deg"></span>
              <span class="text__char" style="--char-rotate: 98.18181818181816deg">-</span>
              <span class="text__char" style="--char-rotate: 114.5454545454545deg"></span>
              <span class="text__char" style="--char-rotate: 130.9090909090909deg">b</span>
              <span class="text__char" style="--char-rotate: 147.2727272727272deg">a</span>
              <span class="text__char" style="--char-rotate: 163.6363636363636deg">r</span>
              <span class="text__char" style="--char-rotate: 1806deg"></span>
              <span class="text__char" style="--char-rotate: 196.3636363636363deg">-</span>
              <span class="text__char" style="--char-rotate: 212.7272727272727deg"></span>
              <span class="text__char" style="--char-rotate: 229.090909090909deg">m</span>
              <span class="text__char" style="--char-rotate: 245.4545454545454deg">a</span>
              <span class="text__char" style="--char-rotate: 261.8181818181818deg">k</span>
              <span class="text__char" style="--char-rotate: 278.1818181818181deg">e</span>
              <span class="text__char" style="--char-rotate: 294.5454545454545deg">u</span>
              <span class="text__char" style="--char-rotate: 310.9090909090908deg">p</span>
              <span class="text__char" style="--char-rotate: 327.2727272727272deg"></span>
              <span class="text__char" style="--char-rotate: 343.6363636363636deg">-</span>
              <span class="text__char" style="--char-rotate: 359.9999999999999deg"></span>
            </div>
          </router-link>
        </div>
        <div ref="swiper" class=" swiper">
          <div class=" swiper-wrapper">

            <div class="swiper-slide" v-for="(product, index) in products" :key="index">
              <Product class="w-100 amazing-product" :product="product" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Product from "@/parts/Front/components/product/Product";
import Swiper from "swiper/swiper-bundle.min";
export default {
  name: "AmazingDiscount",
  components: {
    Product,
  },
  data() {
    return {
      swiper: null,
    };
  },
  props: {
    products: Array,
    link: String,
  },
  mounted() {
    this.swiper = new Swiper(this.$refs.swiper, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        300: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        400: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        500: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 15,
        },

        1200: {
          slidesPerView: 4,
          spaceBetween: 15,
        },
        1550: {
          slidesPerView: 5,
          spaceBetween: 15,
        },

      },
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResizeFunction);
  },
  computed: {
    showCount() {
      return 16;
    },
  },
  methods: {
    hasAny(name) {
      return this[name] && this[name].length;
    },
    getProductMainImageUrl(product) {
      return getImage(product.major_image, "lg");
    },
    onResize() {
      this.setMaxWidth();
    },
    loadTab(name) {
      if (this.loadedTabs.includes(name)) {
        return;
      }
      this.loadedTabs.push(name);
      this[name].forEach((product) => {
        if (!product) return;
        let url = this.getProductMainImageUrl(product);
        let img = new Image();
        img.src = url;
      });
    },
    setMaxWidth() {
      let slidesPerView = this.getSlidesPerView();
      let spaceBetween = slidesPerView.spaceBetween;
      slidesPerView = slidesPerView.slidesPerView;
      this.maxWidth =
        (document.querySelector("#amazing-container").getBoundingClientRect()
          .width -
          spaceBetween * slidesPerView) /
        slidesPerView +
        (window.innerWidth > 768 ? 2 : 0);
    },
    getSlidesPerView() {
      let c = Number.parseInt(window.innerWidth);
      let ok = 1;
      let max = -1;
      Object.keys(breakpoints).forEach((b) => {
        b = Number.parseInt(b);
        if (c > b && b > max) {
          ok = breakpoints[b];
          max = b;
        }
      });
      return ok;
    },
    initSlider(kill = false) {
      this.initSwiper("amazing", kill, () => {
        if (this.slider) {
          this.slider.destroy();
        }
        this.slider = new Swiper("#amazing-container .swiper-container", {
          spaceBetween: 1,
          //   centeredSlides: true,
          // speed: 1400,
          loop: false,
          // autoplay: {
          //   delay: 5000,
          //   disableOnInteraction: false,
          // },
        });
        setTimeout(() => {
          this.minHeight = document
            .querySelector("#amazing-container .swiper-container")
            .getBoundingClientRect().height;
        }, 1700);
      });
    },
    // گرفتن مقدار لازم براساس تعدادی که باید نمایش بدیم بر اساس سایز صفحه


  },
};
</script>
<style scoped>
.content_products_flash {

  padding: 94px 0 20px;
}

.text-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 130px;
  height: 130px;
  background: transparent;
  border-radius: 100%;
  animation: identifier 20s linear infinite;
  text-align: center;
}

.baner_flash img {
  width: 100%;
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
}

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important;
}

.bg-light {
  background-color: #fff;
}

.text__char {
  display: block;
  position: absolute;
  top: 0;
  left: calc(50% - 70px);
  height: 70px;
  width: 140px;
  text-transform: uppercase;
  font-weight: 500;
  font-size: 16px;
  transform-origin: bottom center;
  transform: rotate(var(--char-rotate));
  color: #000;
}

.text-row.border-white:after {
  border: 25px solid #fff;
}

.text-row:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70%;
  height: 70%;
  z-index: -1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.text-row {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 140px;
  height: 140px;
  background: transparent;
  border-radius: 100%;
  animation: identifier 20s linear infinite;
  text-align: center;
}

.badge__emoji {
  display: block;
  margin: 0;
  animation: identifier 20s linear infinite;
  animation-direction: reverse;
  transition: all 0.3s;
}

@keyframes identifier {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(1turn);
    transform: rotate(1turn);
  }
}

.title_products_flash {
  display: flex;
  justify-content: center;

  position: absolute;
  top: -6%;
  left: 50%;
  transform: translate(-50%, -7%);
}

.title_products_flash::after {
  content: "";
  position: absolute;
  top: 80%;
  left: 126%;
  width: 100%;
  height: 50%;
  background-size: contain;
  background-repeat: no-repeat;
  transform: scale(2.5) translate(-50%, -50%);
  z-index: -1;
  background-image: url(../../../../assets/images/bgFlash.svg);
}

.text-row {
  width: 110px;
  height: 110px;
}

.text__char {
  height: 54px;
  width: 140px;
  font-size: 14px;
}

.text-row::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 60%;
  z-index: -1;
  border-radius: 50%;
  transform: translate(-50%, -50%);
}

.title_products_flash::after {
  content: "";
  position: absolute;
  top: 89%;
  left: 126%;
  width: 100%;
  height: 50%;

  transform: scale(2.5) translate(-50%, -50%);
}

.badge__emoji {
  width: 30px;
  height: 30px;
}

@media screen and (max-width: 1200px) {
  .text-row {
    width: 90px;
    height: 90px;
    position: relative;
    top: 13%;
  }

  .text__char {
    height: 47px;
    width: 143px;
    font-size: 14px;
  }

  .text-row::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 54%;
    height: 54%;
    z-index: -1;
    border-radius: 50%;
    transform: translate(-50%, -50%);
  }

  .title_products_flash::after {
    content: "";
    position: absolute;
    top: 160%;
    left: 126%;
    width: 100%;
    height: 80%;
    transform: scale(2.5) translate(-50%, -50%);
  }

  .badge__emoji {
    width: 20px;
    height: 20px;
  }
}


@media screen and (max-width: 580px) {


  .content_products_flash {
    padding: 70px 0 20px;
  }
}

.products__slider {
  background: #bdbcbc4d;
  background-size: 100% 65%;
  background-repeat: no-repeat;
  position: relative;
  top: -10px;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 30px;
}

.products__slider__info {
  position: relative;
  width: 350px;
  flex-shrink: 0;
  z-index: 1000;
}

.products__slider__info__top {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 57px;
  height: 85%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding-left: 15%;
  white-space: nowrap;
  z-index: 3;
}

.products__slider__info__top img {
  max-height: 100%;
}

.products__slider__info__bg {
  height: 106%;
  position: absolute;
  right: -43px;
  top: -18px;
  z-index: 2;
}



.products__slider {
  padding-inline: 1rem;
}

#amazingDiscount .swiper {
  overflow: hidden;

  padding: 7rem 0 1rem;
}

#amazingDiscount .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

#amazingDiscount a {
  color: #ffffff;
}

#amazingDiscount .static-slide {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem;
  border-radius: 20px;
  flex-direction: column;
}

#amazingDiscount .neonText {
  text-align: center;
  color: #fff;
  font-size: 2.2rem;
  animation: pulsate 1.5s infinite alternate;
  text-shadow: 0 0 7px #fff, 0 0 10px #fff, 0 0 21px #fff, 0 0 42px #fb4c1f,
    0 0 82px #fb4c1f, 0 0 92px #fb4c1f, 0 0 102px #fb4c1f, 0 0 151px #fb4c1f;
  font-weight: 500;
  margin-bottom: 26px;
}

#amazingDiscount .static-slide-img {
  width: 200px;
}

.tada {
  -webkit-animation-name: tada;
  animation-name: tada;
  -webkit-animation-duration: 4s;
  animation-duration: 4s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-delay: 1s;
  -webkit-animation-delay: 1s;
}

@-webkit-keyframes tada {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes tada {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulsate {
  100% {
    text-shadow: 0 0 4px #fff, 0 0 11px #fff, 0 0 19px #fff, 0 0 40px #fb4c1f,
      0 0 80px #fb4c1f, 0 0 90px #fb4c1f, 0 0 100px #fb4c1f, 0 0 150px #fb4c1f;
  }

  0% {
    text-shadow: 0 0 2px #fff, 0 0 4px #fff, 0 0 6px #fff, 0 0 10px #fb4c1f,
      0 0 45px #fb4c1f, 0 0 55px #fb4c1f, 0 0 70px #fb4c1f, 0 0 80px #fb4c1f;
  }
}

#amazingDiscount {
  margin-top: 70px;
  overflow: hidden;
}

@media screen and (max-width: 639px) {
  #amazingDiscount {
    margin-top: 25px;
  }

  #amazingDiscount .swiper {
    overflow: hidden;

    padding: 6rem 0 1rem;
  }

  .products__slider {
    padding-inline: .75rem;
  }
}

@media (max-width: 1199px) {
  #amazingDiscount .static-slide-img {
    width: 130px;
  }
}

@media (max-width: 1023px) {
  #amazingDiscount .static-slide-img {
    width: 130px;
  }

  #amazingDiscount .neonText {
    font-size: 2rem;
  }
}

@media (max-width: 991px) {
  #amazingDiscount .static-slide-img {
    width: 200px;
  }
}

@media (max-width: 600px) {
  #amazingDiscount {
    border-radius: 00px;

  }

  #amazingDiscount .neonText {
    font-size: 1.8rem;
    margin-bottom: 22px;
  }
}
</style>
